export const PATHS: Record<string, string> = {
	main: '/',
	login: '/inicia-sesion',
	recu_contra: '/recuperar-contrasenia',
	singin: '/registro',
	menu_dig: '/menu-digital',
	crear_cuenta: '/crear-cuenta',
	Dinam: '/dinamicas'
};